import {
  Component,
  OnInit,
  Optional,
  Inject,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MessageService } from 'src/app/common/services/message.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { TranslateService } from '@ngx-translate/core';
import { FormaterService } from '../../services/formater.service';
import { LanguageService } from 'src/app/common/services/language.service';
import { country } from '../../enums/language';
import { CROSS, PAN} from 'src/defaultImages.js';
import { UtilService } from 'src/app/util/util.service';

@Component({
  selector: 'app-add-item-discount',
  templateUrl: './add-item-discount.component.html',
  styleUrls: ['./add-item-discount.component.css'],
})
export class AddItemDiscountComponent implements OnInit {
  images = { 
    CROSS: CROSS,
    PAN: PAN
  };
  modalTexts: any;
  Currency;
  isBtnLoading: boolean = false;
  tabsGroup = [
    { label: 'FLAT CASH DISCOUNT', value: 'fixed' },
    { label: 'PERCENTAGE DISCOUNT', value: 'percent' },
  ];
  percentageDiscount = [
    { id: 1, name: '5% off', value: '5', type: 'discount' },
    { id: 2, name: '10% off', value: '10', type: 'discount' },
    { id: 3, name: '15% off', value: '15', type: 'discount' },
    { id: 4, name: '20% off', value: '20', type: 'discount' },
  ];
  flatDiscount;
  reasonPresets = [
    { label: 'Celebrations', value: 'celebrations' },
    { label: 'Discount to Staff', value: 'discount_to_staff' },
    { label: 'Loyal Customer', value: 'loyal_customer' },
    { label: 'Issue with Food/Service', value: 'issue_with_food_service' },
    // { label: "Other Reason", value: "other_reason" },
  ];
  customDiscountValue: string = '';
  isRemove: boolean = false;
  selectedAmount: string = '';
  currentTab: string = 'fixed';
  customDiscount: any;
  selectedReason: string;
  selectedDiscount: string;
  isLoading: boolean = false;
  searchFilter: string = '';
  customReason: string = '';
  isPresetEnabled: boolean = false;
  itemQuantity: number = 1;
  @ViewChild('customInput', { static: false }) customInput: ElementRef;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private messageService: MessageService,
    private apiService: ApiService,
    private curr: CurrencyService,
    private translateService: TranslateService,
    public format: FormaterService,
    private _lang: LanguageService,
    public utilService: UtilService

  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
    this.Currency = this.curr.getCurrency();
    this.flatDiscount = [
      { id: 1, name: `${this.Currency} 5`, value: '5', type: 'fixed' },
      { id: 2, name: `${this.Currency} 10`, value: '10', type: 'fixed' },
      { id: 3, name: `${this.Currency} 15`, value: '15', type: 'fixed' },
      { id: 4, name: `${this.Currency} 20`, value: '20', type: 'fixed' },
    ];
  }

  ngOnInit() {
    this.translateService.get('EDIT_AMOUNT').subscribe((data: any) => {
      this.modalTexts = { ...data };
      this.tabsGroup = [
        { label: this.modalTexts.FLAT_CASH_DISCOUNT, value: 'fixed' },
        { label: this.modalTexts.PERCENTAGE_DISCOUNT, value: 'percent' },
      ];
      this.reasonPresets = [
        { label: this.modalTexts.CELEBRATIONS, value: 'celebrations' },
        {
          label: this.modalTexts.DISCOUNT_TO_STAFF,
          value: 'discount_to_staff',
        },
        { label: this.modalTexts.LOYAL_CUSTOMER, value: 'loyal_customer' },
        {
          label: this.modalTexts.ISSUE_WITH_FOOD_SERVICE,
          value: 'issue_with_food_service',
        },
        // { label: "Other Reason", value: "other_reason" },
      ];
    });
    this.itemQuantity = this.data.item.item_quantity
      ? this.data.item.item_quantity
      : this.data.item.quantity;

    (this._lang.getCountry() === country.id.country) && this.setFixedDiscountPresets(); 
  }

  setFixedDiscountPresets(){
    this.flatDiscount = [
      { id: 1, name: `${this.Currency} 10.000`, value: '10000', type: 'fixed' },
      { id: 2, name: `${this.Currency} 25.000`, value: '25000', type: 'fixed' },
      { id: 3, name: `${this.Currency} 50.000`, value: '50000', type: 'fixed' },
      { id: 4, name: `${this.Currency} 100.000`, value: '100000', type: 'fixed' },
    ]
  }

  removeItem() {
    if (this.itemQuantity !== 1) this.itemQuantity = this.itemQuantity - 1;
  }
  addItem() {
    if (
      this.data.item.item_quantity !== this.itemQuantity ||
      this.data.item.quantity !== this.itemQuantity
    )
      this.itemQuantity = this.itemQuantity + 1;
  }
  onRemoveDiscount() {
    if (this.data.item.item_discount) {
      this.isRemove = true;
      this.submit();
    } else {
      this.cancel_clicked();
    }
  }
  cancel_clicked() {
    this.dialogRef.close({ status: 0, data: null, message: 'closed' });
  }
  reasonClicked(reason?) {
    this.selectedReason = reason?.label;
    this.customReason = '';
  }
  discountClicked(item) {
    this.selectedDiscount = item.name;
    this.selectedAmount = item.value;
    this.customDiscountValue = item.name !== 'custom_discount' ? '' : this.customDiscountValue
  }
  getNumber(e) {
    let temp = this.customInput.nativeElement.value;
    this.customInput.nativeElement.value += e;
    if (
      this.currentTab === 'percentage' &&
      parseFloat(this.customInput.nativeElement.value) > 100
    ) {
      this.customInput.nativeElement.value = temp;
    }
    this.customDiscountValue = this.customInput.nativeElement.value;
  }

  getDecimal(e) {
    if (!this.customInput.nativeElement.value.includes(e)) {
      this.customInput.nativeElement.value += e;
      this.customDiscountValue = this.customInput.nativeElement.value;
    }
  }
  inputChanges(e) {
    if (
      this.currentTab === 'percent' &&
      parseFloat(this.format.formatMy(this.customDiscountValue)) > 10
    )
      return false;
    else if (
      this.currentTab === 'percent' &&
      parseFloat(this.format.formatMy(this.customDiscountValue)) === 100 &&
      e.charCode > 43
    )
      return false;
    return e.charCode >= 44 && e.charCode <= 57 && e.charCode !== 47;
  }

  numBack(e) {
    this.customInput.nativeElement.value =
      this.customInput.nativeElement.value.substr(
        0,
        this.customInput.nativeElement.value.length - 1
      );
    this.customDiscountValue = this.customInput.nativeElement.value;
  }
  changeTab(item) {
    this.currentTab = item;
    this.customDiscountValue = null;
    this.selectedReason = null;
    this.selectedDiscount = null;
    this.selectedAmount = null;
    this.customReason = '';
    this.searchFilter = '';
  }
  submit(discountApplied?:boolean) {
    if(discountApplied && !this.customDiscountValue && !this.selectedDiscount){
      this.messageService.showError(this.modalTexts?.ADD_DISCOUNT_VALUE)
      return;
    }
    this.isBtnLoading = true;
    let itemId =
      this.data.source === 'order' ? 'order_item_id' : 'cart_item_id';
    let apiKey = '';
    if(!this.selectedReason && !this.customReason){
      this.customReason = this.modalTexts?.ITEM_LEVEL;
    }
    let itemArray = [
      {
        [itemId]:
          this.data.source === 'order'
            ? this.data.item.order_item_id
            : this.data.item.cart_item_id,
        remove: this.isRemove ? this.isRemove : false,
        qty: +this.itemQuantity,
        type: this.currentTab,
        value: this.customDiscountValue
          ? +this.format.formatMy(this.customDiscountValue)
          : +this.selectedAmount,
        reason: this.customReason ? this.customReason : this.selectedReason,
      },
    ];
    // this.data.item.forEach((x) => {
    // itemArray.push({
    //   [itemId]:
    //     this.data.source === "order"
    //       ? this.data.item.order_item_id
    //       : this.data.item.cart_item_id,
    //   remove: false,
    //   qty: this.itemQuantity,
    //   type: this.currentTab,
    //   value: this.customDiscountValue
    //     ? +this.customDiscountValue
    //     : +this.selectedAmount,
    //   reason: this.customReason ? this.customReason : this.selectedReason,
    // });
    // })

    let payload = {
      level: 'item',
      discount_list: itemArray,
    };
    if (this.data.source === 'order') {
      payload['order_id'] = this.data.id;
      apiKey = 'order';
    } else if (this.data.source === 'cart') {
      payload['cart_token'] = this.data.token;
      payload['order_type'] = +this.data.orderType;
      payload['restaurant_id'] = this.data.rest_id;
      payload['is_foodcourt'] = false;
      apiKey = 'cart';
    }
    this.apiService.itemLevelDiscount(payload, apiKey).subscribe(
      (response) => {
        if ((response || {}).statusCode === 200) {
          this.isBtnLoading = false;
          this.messageService.showSuccess((response.data || {}).message);
          this.dialogRef.close({ status: 0, data: null, message: 'success' });
        } else {
          this.messageService.showError((response.data || {}).message);
          this.isBtnLoading = false;
        }
      },
      (error) => {
        this.messageService.showError((error.error || {}).message);
        this.isBtnLoading = false;
      }
    );
  }
}
